@if (isMultiPillDisplay) {
    @for (value of valuesArray; track value; let last = $last) {
        <span
            class="coloredPillWrapper"
            [ngClass]="multiPillsDisplayMapping ? multiPillsDisplayMapping[value | lowercase] : pillType"
            [class.pill-margin]="!last"
            >{{ value | translate }}</span
        >
    }
} @else {
    <span class="coloredPillWrapper" appTooltip trigger="hover" [componentData]="tooltipText" position="top" [ngClass]="pillType">
        {{ displayValue | translate }}
    </span>
}
